import { IFieldSearchCriteria } from './field-search-criteria';

export class FieldSearchCriteriaCollection {
  searches: IFieldSearchCriteria[] = [];

  constructor() {}

  findByFieldName(fieldName: string): IFieldSearchCriteria {
    return this.searches.find((a) => a.fieldName === fieldName);
  }

  hasCurrentSearches(): boolean {
    return this.getCurrentSearches().length > 0;
  }

  getCurrentSearches(): IFieldSearchCriteria[] {
    return this.searches.filter(
      (a) => a.currentSearch != null && a.currentSearch !== '',
    );
  }

  removeCurrentSearch(fieldName: string) {
    const search = this.findByFieldName(fieldName);
    search.currentSearch = null;
    search.currentSearchDisplay = null;
  }

  addCurrentSearch(
    fieldName: string,
    currentSearch: string,
    currentSearchDisplay: string = null,
  ): void {
    const search = this.findByFieldName(fieldName);

    if (search != null) {
      search.currentSearch = null;
      if (currentSearch != null && currentSearch !== '') {
        search.currentSearch = currentSearch;
        search.currentSearchDisplay = currentSearchDisplay;
      }
    }
  }

  createCurrentSearchObject(): object {
    const currentSearchObject = {};
    this.getCurrentSearches().forEach((element) => {
      currentSearchObject[element.fieldName] = element.currentSearch;
    });
    return currentSearchObject;
  }

  setCurrentSearchFromObject(request: object): void {
    this.searches.forEach((search) => {
      if (request[search.fieldName] == null) {
        this.removeCurrentSearch(search.fieldName);
      }
    });

    Object.keys(request).forEach((key) => {
      this.addCurrentSearch(key, request[key]);
    });
  }

  clear(): void {
    this.searches.forEach((search) => {
      search.currentSearch = null;
    });
  }
}
